import useSWR from 'swr'
import { get } from '@/utils/request'
import { Celebrity } from '@/utils/types'
import { commonSWROptions } from './useAdmin'

const getCelebrities = () =>
  get('celebrities').then((res) => {
    if (res.ok) {
      return res.celebrities
    }
    return []
  })

// 不用 fallbackData:它优先级高于 SWRConfig 的 fallback,会盖掉百科页服务端预取的数据
const useCelebrities = () => {
  const { data, mutate, isValidating } = useSWR<Celebrity[]>('celebrities', getCelebrities, commonSWROptions)
  return { data: data ?? [], mutate, isValidating }
}

export default useCelebrities
